import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PasswordChangeComponent } from './pages/password-change/password-change.component';
import { RolePermissionComponent } from './pages/role-permission/role-permission.component';
import { RoleComponent } from './pages/role/role.component';
import { UserModifyComponent } from './pages/user-modify/user-modify.component';
import { UserPreviewComponent } from './pages/user-preview/user-preview.component';
import { UserSearchComponent } from './pages/user-search/user-search.component';
import { UserDataPermissionComponent } from './pages/user-data-permission/user-data-permission.component';
import { UserSubscribtionPermissionComponent } from './pages/user-subscribtion-permission/user-subscribtion-permission.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';


const routes: Routes = [
  {
    path: '',
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'userSearch',
        component: UserSearchComponent
      },
      {
        path:'userModify',
        component:UserModifyComponent
      },
      {
        path:'userPreview',
        component:UserPreviewComponent
      },
      {
        path: 'role',
        component: RoleComponent
      },
      {
        path: 'rolePermission',
        component: RolePermissionComponent
      },
      {
        path: 'changePassword',
        component: PasswordChangeComponent
      },
      {
        path: 'UserDataPermission',
        component: UserDataPermissionComponent
      },
      {
        path: 'UserSubscribtionPermission',
        component: UserSubscribtionPermissionComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
